import { SearchCombobox } from "~/shared/components/fields/search-combobox.tsx";
import type { Carrier, CarrierPrice } from "~/shared/schemas/carrier-schema.ts";
import { carrierSchema } from "~/shared/schemas/carrier-schema.ts";
import { getBaseUrl } from "~/shared/utils/get-base-url.ts";

const carrierWithDisplayNameSchema = carrierSchema.transform((carrier) => ({
	...carrier,
	displayNameOrName: carrier.displayName ?? carrier.name,
}));

type CarrierNameSectionProps = {
	carrierPrice: CarrierPrice;
	isAdHocCarrier: boolean;
	isDisabled: boolean;
	searchCarrierRoute: (searchTerm: string) => string;
	onCarrierSelection: (carrier: Carrier) => void;
};

export function CarrierNameSection({
	carrierPrice,
	isAdHocCarrier,
	isDisabled,
	searchCarrierRoute,
	onCarrierSelection,
}: Readonly<CarrierNameSectionProps>) {
	const baseUrl = getBaseUrl();

	if (isAdHocCarrier && isDisabled) {
		return (
			<div className={"carrier-card-col carrier-name-title-details"}>
				<div className={"adhoc-search"}>
					<SearchCombobox
						className={""}
						dataItemKey={"id"}
						disabled={false}
						handleChange={(event) => {
							const carrier: Carrier | undefined =
								"value" in event && event.value
									? (event.value as Carrier)
									: undefined;
							if (carrier) {
								onCarrierSelection(carrier);
							}
						}}
						hint={false}
						hintDirection={undefined}
						id={`carrier-search-${carrierPrice.id}`}
						label={""}
						minSearchLength={3}
						name={`carrier-search-${carrierPrice.id}`}
						placeholder={"Search Carrier"}
						route={searchCarrierRoute}
						schema={carrierWithDisplayNameSchema}
						textField={"displayNameOrName"}
						value={undefined}
						wrapperStyle={undefined}
					/>
				</div>
			</div>
		);
	}

	return (
		<div className={"carrier-card-col carrier-name-title-details"}>
			<div>{carrierPrice.carrier.displayName || carrierPrice.carrier.name}</div>
			<div>
				<a
					className={"tql-link"}
					href={`${baseUrl}/documents/carrier-restrictions/ProhibitedCommodities_${carrierPrice.carrier.scac}.pdf`}
					rel={"noopener noreferrer"}
					target={"_blank"}
				>
					View Restrictions
				</a>
			</div>
			{carrierPrice.carrier.isPreferred ? (
				<img
					alt={"Preferred Carrier"}
					className={"preferred-carrier"}
					src={`${baseUrl}/images/preferredCarrier.png`}
				/>
			) : null}
			{carrierPrice.carrier.isCarrierOfTheYear ? (
				<img
					alt={"Carrier of the Year"}
					className={"preferred-carrier"}
					src={`${baseUrl}/images/carrierOfTheYear.png`}
				/>
			) : null}
		</div>
	);
}
